<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>image</mat-icon>

      <span class="font-medium">Afbeelding tonen</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit flex gap-3 items-center">
    <app-avatar class="image-thumbnail" [src]="imageUrl()" [alt]="data().value.label">
      <div class="image-thumbnail-fallback">
        <mat-icon>image</mat-icon>
      </div>
    </app-avatar>

    <div class="flex flex-col gap-0.5 min-w-0">
      <span class="truncate">{{ data().value.label }}</span>
      <span class="text-xs text-gray-500 flex items-center gap-1">
        <mat-icon class="text-base/4! size-4!">timer</mat-icon>
        {{ data().value.duration }} seconden
      </span>
    </div>
  </div>
</div>
